import {
  Button,
  Col,
  Divider,
  Popover,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import {medicineStoreService} from "api";
import {ButtonExcel, ColumnPopoverDisplay} from "components/common";
import Icons from "assets/icons";
import React, {useEffect, useState} from "react";
import {ColumnProps} from "types/models";
import {allColumns} from "./List3.config";
import {useAppSelector} from "redux/hooks";
import {useDispatch} from "react-redux";
import {setActiveKey} from "redux/reducer/common";
import {tabKeys, LOAI_DON_THUOC, FORMAT_TIME} from "types/enums";
import {
  setDetailRecord,
  setEnableSLHoanTra,
  setSelectedRecord,
  setShowHoanLai,
  setTypePrescription,
} from "redux/reducer/medicineStore";
import Notification from "components/common/notification/notification";
import {exportFile, formatDateToString, getTableOptions, saveTableOptions} from "helper/common";
import dayjs from "dayjs";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
const List3 = () => {
  let savedTableOption = getTableOptions(
    "MEDICINE_LIST3_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width??null
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const dispatch = useDispatch();
  const searchForm = useAppSelector(state => state.medicineStore.searchForm);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const activeTabPresciption = useAppSelector(
    state => state.medicineStore.activeTabPresciption
  );
  const selectedRecord = useAppSelector(
    state => state.medicineStore.selectedRecord
  );
  const expandRef = useAppSelector(state => state.medicineStore.expandRef);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState();
  const [columns, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter(e => e.show == true)
  );
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    status: "HL",
    ["thoiGianTra"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
  });
  useEffect(() => {
    if (activeTabPresciption == tabKeys.MEDICINE_STORE.LIST_3) {
      setParams({...params, ...searchForm});
    }
  }, [searchForm]);
  useEffect(() => {
    if (activeTabPresciption == tabKeys.MEDICINE_STORE.LIST_3) {
      getList3(params);
    }
  }, [params, activeTab]);
  useEffect(() => {
    if (activeTabPresciption == tabKeys.MEDICINE_STORE.LIST_3) {
      setParams({...params, page: 1});
    }
  }, [activeTabPresciption]);
  const getList3 = async params => {
    setSelectedRowKeys([]);
    try {
      setLoading(true);
      const res = await medicineStoreService.getListPrescription1(params);
      const data = res.data.map(e => ({...e, key: e.id}));
      // 
      setTotal(res.total);
      setData(data);
      setLoading(false);
      // 
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi lấy danh sách đơn bán");
    }
  };
  const setShowColumns = showColumns => {
    saveTableOptions(
      "MEDICINE_LIST3_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const onChangePagination = (page, pageSize) => {
    setParams({...params, page: page, limit: pageSize});
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeys([selectedRowKeys[selectedRowKeys.length - 1]]);
      if (selectedRows.length == 0) {
        dispatch(setSelectedRecord(null));
        dispatch(setDetailRecord(null));
      }
      {
        dispatch(setSelectedRecord(selectedRows[selectedRows.length - 1]));
      }
    },
    hideSelectAll: true,
    selections: [Table.SELECTION_NONE],
  };

  const onDetail = (typePrescription: LOAI_DON_THUOC) => {
    dispatch(setShowHoanLai(true));
    dispatch(setEnableSLHoanTra(false));
    dispatch(setTypePrescription(typePrescription));
    // if (typePrescription == LOAI_DON_THUOC.TAO_MOI) {
    //   dispatch(setSelectedRecord(null));
    //   dispatch(setDetailRecord(null));
    // }
    dispatch(setActiveKey(tabKeys.MEDICINE_STORE.PRESCRIPTION_DETAIL));
  };

  return (
    <div className="container">
      <Space style={{width: "100%"}} direction="vertical">
        <Typography.Text strong>Danh sách đơn thuốc hoàn trả</Typography.Text>
        <Divider type="horizontal" style={{margin: "0"}} />
        <Row justify={"end"} gutter={[16, 8]}>
          <Col>
            <Space style={{width: "100%"}}>
              <Popover
                trigger="click"
                placement="topLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowColumns}
                    columns={defaultColumns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button
                  icon={<Icons.bars rev={0} />}
                  className="btn-sub"
                  type="ghost"
                >
                  Cột hiển thị
                </Button>
              </Popover>

              {/* <Button
                icon={<Icons.file rev={0} />}
                className="btn-sub"
                type="ghost"
                onClick={() => {
                  if (selectedRowKeys.length == 0) {
                    dispatch(setSelectedRecord(null));
                    dispatch(setDetailRecord(null));
                  }
                  onDetail(LOAI_DON_THUOC.TAO_MOI);
                }}
              >
                Tạo đơn mới
              </Button> */}
              <Button
                icon={<Icons.file rev={0} />}
                className="btn-sub"
                type="ghost"
                onClick={() => {
                  if (selectedRowKeys.length == 0) {
                    dispatch(setSelectedRecord(null));
                    dispatch(setDetailRecord(null));
                  }
                  if (selectedRecord) {
                    onDetail(LOAI_DON_THUOC.DA_TAO);
                  } else {
                    Notification("warning", "Chưa chọn đơn thuốc");
                  }
                }}
              >
                Chi tiết đơn thuốc
              </Button>
            </Space>
          </Col>
        </Row>
        <CustomResizableTable
          setShowColumns={setShowColumns}
          columns={columns}
          dataSource={data}
          // className="custom-resize-table-scroll"
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            total: total,
            onChange: onChangePagination,
          }}
          rowSelection={{
            ...rowSelection,
          }}
          bordered={true}
          loading={loading}
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: event => {
                dispatch(setSelectedRecord(record));
                onDetail(LOAI_DON_THUOC.DA_TAO);
              }, // double click row
            };
          }}
        />
      </Space>
    </div>
  );
};
export default List3;
